<template>
	<v-switch
		:input-value="value"
		:hide-details="hideDetails"
		:label="label"
		v-bind="$attrs"
		v-on="unhandled_events"
		@change="on_change"
	>
		<slot />
	</v-switch>
</template>

<script>
export default {
	name: 'KSwitch',
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			default: undefined
		},
		hideDetails: {
			type: [Boolean, String],
			default: 'auto'
		},
		label: {
			type: String,
			default: undefined
		}
	},
	methods: {
		on_change(value) {
			this.$emit('change', value)
		}
	},
	computed: {
		unhandled_events() {
			const { change, ...listeners } = this.$listeners
			return listeners
		}
	}
}
</script>
